import { render, staticRenderFns } from "./EditAttachements.vue?vue&type=template&id=09588e06&scoped=true"
import script from "./EditAttachements.vue?vue&type=script&lang=js"
export * from "./EditAttachements.vue?vue&type=script&lang=js"
import style0 from "./EditAttachements.vue?vue&type=style&index=0&id=09588e06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09588e06",
  null
  
)

export default component.exports